import {apiClient} from '../client'

export const fetchReports = async (id, building_id) => {
  const {report, meta} = await apiClient.get(`projects/${id}/buildings/${building_id}/report`)
  return {report, meta}
}
